import {
  blackListPaginated,
  blacklistPaginatedContent
} from 'types/PreTicketBlackListTypes';
import useHttp from '../helpers/HttpMethods';

class PreTicketBlackListService {
  /**
   * Busca todas as blacklists.
   * @param {string} filter - Filtro em formato de string.
   * @returns {Promise<blackListPaginated>} - Pre tickets em formato paginado.
   */
  static async list(filter: string): Promise<blackListPaginated> {
    return await useHttp().get(`/pre-tickets/blacklist?${filter}`);
  }

  /**
   * Adiciona e-mail(s) à blacklist de pré-ticket.
   * @param {{ sender: string[] }} body - Array de e-mails.
   * @returns {Promise<blacklistPaginatedContent[]>} - Retorna os itens criados.
   */
  static async add(body: {
    sender: string[];
  }): Promise<blacklistPaginatedContent[]> {
    return await useHttp().post(body, `/pre-tickets/blacklist`);
  }

  /**
   * Exclui uma blacklist.
   * @param {number} id - ID da blacklist a ser excluída.
   * @returns {Promise<Response>} - Retorno padrão de uma request.
   */
  static async delete(id: number): Promise<Response> {
    return await useHttp().del(`/pre-tickets/blacklist/${id}`);
  }
}

export default PreTicketBlackListService;
